const accessToken = JSON.parse(localStorage.getItem("authUser"));
export default accessToken



// const obj = JSON.parse(localStorage.getItem("authUser"))
// const accessToken = obj.authUser
// console.log(accessToken)
// export default accessToken
